import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonRoute,
  IonRow,
  IonSearchbar,
  IonTitle,
  IonToast,
  IonToolbar,
  useIonViewWillEnter,
} from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router";
import "../../components/ExploreContainer.css";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import { requestID, baseUrl, config } from "../../common/utils";

import NativeSelect from "@mui/material/NativeSelect";
import InputBase from "@mui/material/InputBase";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useBusinessContext } from "../../context/business-context";

const LedgerPosting = () => {


  const schema = yup
    .object({
      creditedQueryValue: yup.string().required("Please select a credit ledger"),
      transType: yup.string().required("Please select a debit ledger."),
      amount: yup.string().required("Please enter an amount."),
      desp: yup.string().required("Please enter transaction description"),
      reference: yup.string().required("Please select a references"),
      referenceDetail: yup.string().required("Please enter reference detail"),
    })
    .required();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { name } = useParams<{ name: string }>();

  const [ledgetType, setLedgetType] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [ledgerMother, setLedgerMother] = useState([]);
  const [recData, setRecData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [drName, setDrname] = useState("");
  const [crName, setCrname] = useState("");
  const [status, setStatus] = useState({ loading: false, error: false });
  const [errorLogin, setErrorLogin] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [ratingRange, setRatingRange] = useState("0");
  const [message, setMessage] = useState("");
  const [showme, setShowme] = useState(true);
  const [ledgerName, setLedgerName] = useState("");
  const [allLedger, setAllLedger] = useState([]);
  const [checkTeller, setcheckTeller] = useState<Boolean>(false);

  const [transMode, setTransMode] = useState("");
  const [post_sn, setPOst_sn] = useState("");
  const [transType, setTransType] = useState("");
  const [ledgerNo, setLedgerNo] = useState("");
  const [reference, setReference] = useState("");
  const [referenceDetail, setreferenceDetail] = useState("");
  const [amount, setAmount] = useState("");

  const [inputValue, setInputValue] = React.useState("");
  const [tellerFormData, SetTellerFormData] = useState([]);
  const [appSettings, setAppsettings] = useState([]);
  const [query, setQuery] = useState("");
  const [creditedQuery, setCreditedQuery] = useState("");

  const [desp, setDesp] = useState("");
  const [squery, SetSquery] = useState("");
  const [creditedPostSn, setCreditedPostSn] = useState("");
  const [creditedQueryValue, setCreditedQueryValue] = useState("");

  const checkTellerx = () => {
    checkTeller ? setcheckTeller(false) : setcheckTeller(true);
    console.log(checkTeller);
  };

  const history = useHistory();
  const callToast = () => {
    setShowToast(true);
    setTimeout(() => setShowToast(false), 5000);
  };
    const {selectedBusiness } = useBusinessContext()
  

  const getLedgers = () => {
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("business_id", selectedBusiness.business_id)
    formData.append("branch_id", selectedBusiness.branch_id)
    // formData.append("shopID", id);
    setStatus({ loading: true, error: false });
    axios
      .post(baseUrl() + "ledgercreates/getAllLedger_caas_branch", formData, config)
      .then((response) => {
        console.log(response);
        console.log(response.data.data);

        setAllLedger(response.data.data);

        setStatus({ loading: false, error: false });
      })
      .catch((error) => {
        setStatus({ loading: false, error: false });
        // throw new error("hey ");
      });
  };

  const getTellerFormData = () => {
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("business_id", selectedBusiness.business_id)
    formData.append("branch_id", selectedBusiness.branch_id)
    // formData.append("shopID", id);
    setStatus({ loading: true, error: false });
    axios
      .post(baseUrl() + "ledgercreates/getTellerFormData_caas", formData, config)
      .then((response) => {
        console.log(response);
        console.log(response.data.data);

        SetTellerFormData(response.data.data);

        setStatus({ loading: false, error: false });
      })
      .catch((error) => {
        setStatus({ loading: false, error: false });
        // throw new error("hey ");
      });
  };

  const postLedger = () => {
    setStatus({ loading: true, error: false });
    const formData = new FormData();

    formData.append("requestID", requestID());
    formData.append("amount", amount);
    formData.append("transMode_sn", transMode);
    formData.append("transType", transType);
    formData.append("post_sn", creditedPostSn);
    formData.append("desp", desp);
    formData.append("reference", reference);
    formData.append("referenceDetail", referenceDetail);
    formData.append("checkPrint", checkTeller.toString());
    formData.append("business_id", selectedBusiness.business_id)
    formData.append("branch_id", selectedBusiness.branch_id)

    axios
      .post(baseUrl() + "ledgers/postLedgerAccount_caas", formData, config)
      .then((response) => {
        console.log(response);

        console.log(response.data.data);

      if(response.data.status == true
      ){
        setAppsettings(response.data.appSettings);
        setRecData(response.data.data);
        setDrname(response.data.drName);
        setCrname(response.data.crName);

        setAmount("");
        setreferenceDetail("");
        setReference("");
        setDesp("");
        setcheckTeller(false);
        setCreditedPostSn('');
        setCreditedQueryValue('');

      setCreditedQuery('')
      setCreditedQueryValue('')
      setCreditedPostSn
setCreditedPostSn('')

        setTransMode("");
        setTransType("");
        getTellerFormData()
        reset()
      }
  

        if (response.data.checkPrint === "true") {
          setIsOpen(true);
        }

        setStatus({ loading: false, error: true });

        response.data.status === "false"
          ? setErrorLogin("Failed!")
          : setErrorLogin("Ledger Added Successfully !");

        callToast();
        // response.data.status === 'false' ? '' :history.push("/folder/manageLedger/Manage Ledger")    ;
      })
      .catch((error) => {
        setStatus({ loading: false, error: true });
        callToast();
        // throw new error("hey ");
      });
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const filteredShops = allLedger?.filter((allLedger) =>
    allLedger?.name
      .toLowerCase()
      .includes(query.toLowerCase() || creditedQuery.toLowerCase())
  );

  const queryEmpty = () => {
    SetSquery("");
  };

  const queryKeep = (name: string, sn: string) => {
    setTransType(name);
    setTransMode(sn);
    setQuery("");
  };
  const creditQuery = (name: string, sn: string) => {
    setCreditedPostSn(sn);
    setCreditedQueryValue(name);
    setCreditedQuery("");
  };

  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }));
  //const [isOpen, setIsOpen] = useState(false);
  const [isOp, setisOp] = useState(false);
  const setisOpx = () => {
    setisOp(true);
  };
  //const history = useHistory();

  const modal = useRef<HTMLIonModalElement>(null);
  const page = useRef(null);

  const [presentingElement, setPresentingElement] =
    useState<HTMLElement | null>(null);

  useEffect(() => {
    setPresentingElement(page.current);
  }, []);

  function dismiss() {
    modal.current?.dismiss();
  }

  async function canDismiss(data?: any, role?: string) {
    return role !== "gesture";
  }

  useIonViewWillEnter(() => {
    getLedgers();
    getTellerFormData();
    // fetchShopsById();
  });

  return (
    <IonPage className="pushDown" ref={page}>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        {checkTeller && (
          <IonModal isOpen={isOpen}>
            <IonHeader>
              <IonToolbar>
                <IonTitle>Transaction Reciept</IonTitle>
                <IonButtons slot="end">
                  <IonButton onClick={() => setIsOpen(false)}>Close</IonButton>
                </IonButtons>
              </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
              <div className="recieptHead">
                <h5>
                  {appSettings?.name}
                  <br></br>
                  {appSettings?.address}
                </h5>
              </div>
              <br></br> <br></br>
              <IonRow>
                <IonCol>Transaction ID: </IonCol>
                <IonCol>{recData[0]?.postCode}</IonCol>
              </IonRow>
              <IonRow>
                <IonCol>Transaction Date: </IonCol>
                <IonCol>{recData[0]?.finDate}</IonCol>
              </IonRow>
              <IonRow>
                <IonCol>Dr Account Name: </IonCol>
                <IonCol>{drName}</IonCol>
              </IonRow>
              <IonRow>
                <IonCol>Cr Account Name: </IonCol>
                <IonCol>{crName}</IonCol>
              </IonRow>
              <IonRow>
                <IonCol>Description: </IonCol>
                <IonCol>{recData[0]?.desp}</IonCol>
              </IonRow>
              <Divider orientation="horizontal" flexItem />
              <Divider orientation="horizontal" flexItem />
              <IonRow>
                <IonCol>Amount: </IonCol>
                <IonCol>
                  {recData[0]?.cr < 1 ? recData[0]?.dr : recData[0]?.cr}
                </IonCol>
              </IonRow>
              <Divider orientation="horizontal" flexItem />
              <Divider orientation="horizontal" flexItem />
            </IonContent>

            <IonButton mode="md" expand="full" color="success">
              {" "}
              Print{" "}
            </IonButton>
          </IonModal>
        )}

        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <Box
          sx={{
            paddingTop: "20px",
            display: "flex",

            "& > :not(style)": { m: 1 },
          }}
        >
          <h5> Posting Form</h5>

          <Divider orientation="horizontal" flexItem />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",

            paddingTop: "20px",
            paddingLeft: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <InputLabel id="demo-simple-select-label">
            {" "}
            Transaction Date:{" "}
          </InputLabel>

          <InputLabel id="demo-simple-select-label"> 23-04-2024</InputLabel>
        </Box>

        <Divider orientation="horizontal" flexItem />
        {/* <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingRight: "20px",
            paddingLeft: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <FormControl fullWidth sx={{ m: 1 }} variant="standard">
            <InputLabel id="demo-simple-select-label">
              Select Mode Of Payment:
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={transMode}
              label="Select Mode Of Payment:
"
              onChange={(event) => {
                setTransMode(event.target.value);
              }}
            >
              {tellerFormData?.map((tellerFormData) => {
                return (
                  <MenuItem key={tellerFormData.id} value={tellerFormData.sn}>
                    {tellerFormData.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ m: 1 }} variant="standard">
            <InputLabel id="demo-simple-select-label">
              {" "}
              Transaction Type:
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={transType}
              label="Transaction Type:
"
              onChange={(event) => {
                setTransType(event.target.value);
              }}
            >
              <MenuItem key={"1"} value={"cr"}>
                {"Credit"}
              </MenuItem>
              <MenuItem key={"2"} value={"dr"}>
                {"Debit"}
              </MenuItem>
            </Select>
          </FormControl>
        </Box> */}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingRight: "20px",
            paddingLeft: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          {/* <IonLabel>Debit</IonLabel> <br /> */}

          <FormControl fullWidth>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Search Ledger (DEBIT)"
              error={!!errors.transType}
              {...register('transType')}
              helperText={errors.transType?.message
              }
              value={transType}
              onClick={queryEmpty}
              // onCha={(event) => {
              //   setQuery(event.detail.value), setTransType(event.detail.value);
              // }}
              onChange={(event) => {
                setQuery(event.target.value), setTransType(event.target.value);
              }}
              required
            />

            {/* <IonSearchbar
              className="searchBar"
              
              placeholder="Search Ledger"
              value={transType}
              onClick={queryEmpty}
              mode="ios"
              animated={true}
              onIonInput={(event) => {
                setQuery(event.detail.value), setTransType(event.detail.value);
              }}
            ></IonSearchbar> */}

            {query != "" && (
              <IonList className="buyer_searchCan">
                {filteredShops?.map((result, i) => {
                  return (
                    <IonItem
                      key={i}
                      lines="none"
                      className="buyer_searchShop"
                      onClick={(event) => {
                        queryKeep(result?.name, result?.sn);
                      }}
                    >
                      {result?.name}
                    </IonItem>
                  );
                })}
              </IonList>
            )}
            {/* <IonList> */}
            {query != "" && filteredShops?.length < 1 && (
              <IonItem lines="none"> No searched ledger found dr</IonItem>
            )}
          </FormControl>

          {/* <IonLabel
    > Credit</IonLabel> */}
          {/* ////////////// */}
          <FormControl fullWidth>
            {/* <IonSearchbar
              className="searchBar"
              placeholder="Search Ledger"
              value={creditedQueryValue}
              onClick={()=>setCreditedQueryValue('')}
              mode="ios"
              animated={true}
              onIonInput={(event) => {
                setCreditedQuery(event.detail.value)
                setCreditedQueryValue(event.detail.value);
              }}
            ></IonSearchbar> */}

            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Search Ledger (CREDIT)"
              error={!!errors.creditedQueryValue}
              {...register('creditedQueryValue')}
              helperText={errors.creditedQueryValue?.message
              }
              value={creditedQueryValue}
              onClick={() => setCreditedQueryValue("")}
              onChange={(event) => {
                setCreditedQuery(event.target.value);
                setCreditedQueryValue(event.target.value);
              }}
              required
            />

            {creditedQuery != "" && (
              <IonList className="buyer_searchCan">
                {filteredShops?.map((result, i) => {
                  return (
                    <IonItem
                      key={i}
                      lines="none"
                      className="buyer_searchShop"
                      onClick={(event) => {
                        creditQuery(result?.name, result?.sn);
                      }}
                    >
                      {result?.name}
                    </IonItem>
                  );
                })}
              </IonList>
            )}
            {/* <IonList> */}
            {creditedQuery != "" && filteredShops?.length < 1 && (
              <IonItem lines="none"> No ledger found cr</IonItem>
            )}
          </FormControl>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingRight: "20px",
            paddingLeft: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label"></InputLabel>
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              error={!!errors.desp}
              {...register('desp')}
              helperText={errors.desp?.message
              }
              label="Transaction Description"
              value={desp}
              rows={12}
              onChange={(event) => {
                setDesp(event.target.value);
              }}
            />
          </FormControl>

          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label"></InputLabel>
            <TextField
              type="number"
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Amount"
              error={!!errors.amount}
              {...register('amount')}
              helperText={errors.amount?.message
              }
              value={amount}
              onChange={(event) => {
                setAmount(event.target.value);
              }}
            />
          </FormControl>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingRight: "20px",
            paddingLeft: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <FormControl fullWidth sx={{ m: 1 }} variant="standard">
            <InputLabel id="demo-simple-select-label"> References:</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              //input={<BootstrapInput />}
              error={!!errors.reference}
              {...register('reference')}
              // helperText={errors.reference?.message
              // }
              value={reference}
              label="reference:"
              onChange={(event) => {
                setReference(event.target.value);
              }}
            >
              <MenuItem key={1} value={"depoNo"}>
                {"DEPOSIT SLIP NO."}
              </MenuItem>
              <MenuItem key={2} value={"chequeNo"}>
                {"CHEQUE NO."}
              </MenuItem>
              <MenuItem key={3} value={"posNo"}>
                {"POINT OF SALE-(POS-Terminal) NO."}
              </MenuItem>
              <MenuItem key={4} value={"pvNo"}>
                {"PAYMENT VOUCHER NO."}
              </MenuItem>
              <MenuItem key={5} value={"trfNo"}>
                {"TRANSFER REFERENCE"}
              </MenuItem>
              <MenuItem key={6} value={"recNo"}>
                {"RECEIPT NO."}
              </MenuItem>
            </Select>
            <Typography color={'red'} component={'h6'}>{errors.reference?.message}</Typography>
          </FormControl>

          <FormControl fullWidth sx={{ m: 1 }} variant="standard">
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              error={!!errors.referenceDetail}
              {...register('referenceDetail')}
              helperText={errors.referenceDetail?.message
              }
              label="Reference Details:"
              value={referenceDetail}
              onChange={(event) => {
                setreferenceDetail(event.target.value);
              }}
            />
          </FormControl>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "right",
            float: "right",
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          {" "}
          <FormControlLabel
            control={
              <Checkbox
                checked={checkTeller}
                onClick={checkTellerx}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label="Print Reciept"
          />
          <Button onClick={handleSubmit(postLedger)} variant="contained">
            Post Transaction
          </Button>
        </Box>

        <IonLoading
          message="Please Wait, Loading..."
          spinner="circles"
          isOpen={status.loading}
        />
        {status.error && (
          <IonToast position="middle" isOpen={showToast} message={errorLogin} />
        )}
      </IonContent>
    </IonPage>
  );
};

export default LedgerPosting;
